export class MembershipSubscription {
    id: string;
    title: string;
    description: string;
    partnerId: string;
    price: number;
    currency: string;
    isActive: boolean;
}
